var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", {
    staticClass: "dropdown-item cursor-pointer",
    domProps: { textContent: _vm._s(_vm.getLabelText) },
    on: { click: _vm.handle },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }